import { IntlShape } from 'react-intl';

export const getLanguageName = (intl: IntlShape, locale: string) => {
  const languageCode = locale.split('_')[0];
  return intl.formatDisplayName(languageCode, { type: 'language' }) || locale;
};
